import {combineReducers} from 'redux';
import signUp, {ISignUpState} from '../modules/sign-up/reducer';
import auth, {IAuthState} from '../modules/auth/reducer';

export interface IStore {
  signUp: ISignUpState;
  auth: IAuthState;
}

export default combineReducers({
  signUp,
  auth,
});
